import React, { useEffect, useState } from "react";
import API from "../services/http-helper.service";
import { Box, Card, CircularProgress, Grid, makeStyles, Typography } from "@material-ui/core";
import ImagePopup from "../review-portal/components/form-element/ImagePopup";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    marginTop: 0,
  },
  loaderBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "75px",
    width: "100px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
    border: "1px dashed #bdbdbd",
  },
  loaderText: {
    marginTop: "6px",
    fontSize: "10px",
    color: "#9e9e9e",
  },
}));

export function ImageComponent({ imageList }) {
  const [imageDataList, setImageDataList] = useState([]);
  const [loadingIds, setLoadingIds] = useState([]);
  const [imageOpen, setImageOpen] = React.useState(false);
  const [imageDetails, setImageDetails] = useState({});
  const classes = useStyles();

  useEffect(() => {
    if (imageList?.length > 0) {
      setImageDataList([]);
      const ids = imageList.map((val) => (typeof val === "string" ? val : val.imageId)).filter(Boolean);
      setLoadingIds(ids);
      ids.forEach((id) => getFormImage(id));
    }
  }, [imageList]);

  const getFormImage = async (id) => {
    try {
      let res = await API.get(`images/${id}`);
      if (res.status === 200) {
        setImageDataList((prevData) => [
          ...prevData,
          {
            imageId: id,
            fileUrl: res?.data?.attachments?.[0]?.file || "",
            fileName: res?.data?.attachments?.[0]?.fileName || "",
          },
        ]);
      }
    } catch (e) {
      return null;
    } finally {
      setLoadingIds((prev) => prev.filter((imgId) => imgId !== id));
    }
  };

  const onClickAvatar = (item) => {
    setImageDetails(item);
    setImageOpen(true);
  };

  const onClose = () => {
    setImageOpen(false);
  };

  if (!imageList?.length) return null;

  return (
    <Card className={classes.root}>
      <Box>
        <Grid container spacing={2}>
          {imageList.map((val, index) => {
            const id = typeof val === "string" ? val : val.imageId;
            const isLoading = loadingIds.includes(id);
            const loaded = imageDataList.find((img) => img.imageId === id);
            return (
              <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                {isLoading ? (
                  <Box className={classes.loaderBox}>
                    <CircularProgress size={24} thickness={4} />
                    <Typography className={classes.loaderText}>
                      Loading...
                    </Typography>
                  </Box>
                ) : loaded ? (
                  <img
                    src={loaded.fileUrl}
                    alt={`image-${index + 1}`}
                    style={{
                      height: "75px",
                      width: "100px",
                      cursor: "pointer",
                    }}
                    onClick={() => onClickAvatar(loaded)}
                  />
                ) : null}
              </Grid>
            );
          })}
          <ImagePopup
            open={imageOpen}
            onClose={onClose}
            imageUrl={imageDetails.fileUrl}
            title={imageDetails.fileName}
          />
        </Grid>
      </Box>
    </Card>
  );
}
